import {
  getIconSizeProps,
  type IconProps,
} from '@packages/webshop-design-system';

/** Trenitalia France carriage pictogram (BR-57773). */
export const TifCarriageIcon = (props: IconProps) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="14 26 70 42"
    fill="none"
    {...getIconSizeProps(12, 12, props)}
  >
    <g opacity={0.7} fill="currentColor">
      <rect
        x="41.66"
        y="35.3"
        width="9.43"
        height="5.88"
        rx=".85"
        ry=".85"
        transform="translate(92.75 76.47) rotate(-180)"
      />
      <path d="M50.42,41.57h-8.08c-.59,0-1.07-.48-1.07-1.07v-4.53c0-.59.48-1.07,1.07-1.07h8.08c.59,0,1.07.48,1.07,1.07v4.53c0,.59-.48,1.07-1.07,1.07ZM42.34,35.69c-.15,0-.28.12-.28.28v4.53c0,.15.12.28.28.28h8.08c.15,0,.28-.12.28-.28v-4.53c0-.15-.12-.28-.28-.28h-8.08Z" />
      <rect
        x="29.8"
        y="35.3"
        width="9.43"
        height="5.88"
        rx=".85"
        ry=".85"
        transform="translate(69.02 76.47) rotate(-180)"
      />
      <path d="M38.55,41.57h-8.08c-.59,0-1.07-.48-1.07-1.07v-4.53c0-.59.48-1.07,1.07-1.07h8.08c.59,0,1.07.48,1.07,1.07v4.53c0,.59-.48,1.07-1.07,1.07ZM30.47,35.69c-.15,0-.28.12-.28.28v4.53c0,.15.12.28.28.28h8.08c.15,0,.28-.12.28-.28v-4.53c0-.15-.12-.28-.28-.28h-8.08Z" />
      <rect
        x="17.93"
        y="35.3"
        width="9.43"
        height="5.88"
        rx=".85"
        ry=".85"
        transform="translate(45.29 76.47) rotate(-180)"
      />
      <path d="M26.69,41.57h-8.08c-.59,0-1.07-.48-1.07-1.07v-4.53c0-.59.48-1.07,1.07-1.07h8.08c.59,0,1.07.48,1.07,1.07v4.53c0,.59-.48,1.07-1.07,1.07ZM18.6,35.69c-.15,0-.28.12-.28.28v4.53c0,.15.12.28.28.28h8.08c.15,0,.28-.12.28-.28v-4.53c0-.15-.12-.28-.28-.28h-8.08Z" />
      <path d="M70.35,48.71c-.85,0-1.76-.02-2.71-.06l-.4-.02h-28.04s0-1.58,0-1.58l28.51.02c9.27.39,11.46-1.25,11.94-2.27.56-1.19-.65-2.93-1.77-4.18-8.5-9.5-15.59-9.61-15.66-9.61H28.24v-1.58h33.98c.32,0,7.88.12,16.84,10.14,2.09,2.34,2.77,4.33,2.02,5.91-1.03,2.17-4.54,3.23-10.73,3.23Z" />
      <path d="M77.29,38.82c-3.33.25-4.42-.4-5.63-1.17-.72-.46-4.68-3.13-6.19-4.19-.31-.22-.35-.66-.09-.94l1.2-1.27,2.95,1.41,4.19,2.87,3.57,3.28Z" />
      <path d="M75.95,39.27c-2.48,0-3.47-.63-4.51-1.29-.74-.47-4.69-3.13-6.21-4.2-.24-.17-.4-.44-.42-.73-.03-.29.07-.59.27-.8l1.4-1.48,3.21,1.54,4.24,2.9,4.28,3.93-.91.07c-.5.04-.95.05-1.36.05ZM66.67,31.74l-1,1.06c-.06.07-.06.14-.06.18,0,.04.02.11.09.16,1.51,1.06,5.44,3.71,6.18,4.18,1.03.65,1.93,1.22,4.45,1.16l-2.87-2.64-4.15-2.84-2.64-1.26Z" />
      <rect x="38.85" y="55.06" width="42.15" height="1.58" />
      <rect x="38.85" y="62.32" width="42.15" height="1.58" />
      <rect x="44.79" y="55.85" width="1.58" height="7.25" />
      <rect x="48.53" y="55.85" width="1.58" height="7.25" />
      <rect x="52.27" y="55.85" width="1.58" height="7.25" />
      <rect x="56.01" y="55.85" width="1.58" height="7.25" />
      <rect x="59.75" y="55.85" width="1.58" height="7.25" />
      <rect x="63.49" y="55.85" width="1.58" height="7.25" />
      <rect x="67.23" y="55.85" width="1.58" height="7.25" />
      <rect x="70.97" y="55.85" width="1.58" height="7.25" />
      <rect x="74.71" y="55.85" width="1.58" height="7.25" />
      <rect x="78.45" y="55.85" width="1.58" height="7.25" />
    </g>
  </svg>
);
